import { convertDateFormat } from '../utils/methods';
import { AppHeaderBackButton } from '@ace-clublabs/shared-component-library';
import { Header } from './Header';
import { useEffect } from 'react';
import { useGlobalState } from '../shared/state';
import { useNavigate } from 'react-router-dom';
import { Pages } from '../shared/pages';
import { SingleAmountContainer } from '@ace-clublabs/payments-component-library';
import { UtagHelper, UtagParam } from '../utils/utagHelper';
import { PolicyType } from '../shared/types';
import { ProductType } from '@ace-clublabs/payment-types';

export const AutoPayMinDue: React.FC = () => {
  return <AutoPayMinDueView />;
};

export const AutoPayMinDueView: React.FC = () => {
  const [billPlan] = useGlobalState('billPlan');
  const [clubCode] = useGlobalState('clubCode');
  const [selectedProduct] = useGlobalState('selectedProduct') as any;
  const [, setNewEnroll] = useGlobalState('newEnroll');
  const [sessionId] = useGlobalState('sessionId');
  const [discount] = useGlobalState('discount');
  const [referrer] = useGlobalState('referrer');
  const navigate = useNavigate();
  const { policyType, inRenewal, autoPay } = selectedProduct;

  const productType = selectedProduct
    ? policyType === PolicyType.Membership
      ? ProductType.Membership
      : ProductType.Insurance
    : undefined;

  const discountEligible = policyType === PolicyType.Membership && inRenewal && discount > 0;

  const isMembership = policyType === PolicyType.Membership;

  const isMssEnrollShortcut =
    isMembership && !autoPay?.enrolled && referrer?.toLowerCase().includes('membership/selfservice');

  useEffect(() => {
    const baseTags = {
      ...UtagHelper.CommonTaggingValues,
      clubcode: clubCode,
      sessionid: sessionId,
      ...(billPlan && { mem_billplan: billPlan.toLowerCase() }),
      ...(selectedProduct && { flow: productType === ProductType.Membership ? 'membership' : 'insurance' }),
    } as UtagParam;

    UtagHelper.tag({
      ...baseTags,
      page: UtagHelper.Pages.reviewPayment,
    });
  }, []);

  let policyDueDate: string = selectedProduct?.dueDate!;
  let minDue: number = selectedProduct?.minDue || 0;

  const today = new Date();
  const todayString = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(
    today.getDate()
  ).padStart(2, '0')}`;
  let isPastDue: boolean = policyDueDate ? policyDueDate < todayString : false;
  let isFutureDate: boolean = policyDueDate ? policyDueDate > todayString : false;

  let dueDate = policyDueDate ? convertDateFormat(policyDueDate) : undefined;

  const minDueProps = {
    header: `To enroll in Auto Pay, you'll first need to pay the minimum amount due on your account`,
    title: 'Minimum due',
    amountDue: minDue,
    subtitle: isPastDue ? `Payment past due on ${dueDate}` : isFutureDate ? `Payment due on ${dueDate}` : '',
    subtitleWarning: isPastDue,
    autoPayDiscount: discountEligible ? { discount, text: 'Auto Pay discount' } : undefined,
    onClick: () => {
      setNewEnroll(selectedProduct.productId);
      navigate(Pages.AutoPayConsent);
    },
  };

  return (
    <div className="container">
      <Header />
      <AppHeaderBackButton
        id="back-button"
        onClick={() => (isMssEnrollShortcut ? window.location.assign(referrer) : navigate(-1))}
      />
      <SingleAmountContainer {...minDueProps}></SingleAmountContainer>
    </div>
  );
};
